import React from 'react';
import './Menu.css';

class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuState : undefined,
        };

    };
    static getDerivedStateFromProps(nextProps, prevState){
        return {
            menuState : nextProps.menuState
        };
    }

    menuStateFunc = () => {
        if (this.state.menuState === undefined) {
            return 'menu close1'
        } else if (this.state.menuState === true) {
            return 'menu close1 open'
        } else if (this.state.menuState === false) {
            return 'menu close1 closeMenu'
        }
    };
    render() {
        return (
            <div className={this.menuStateFunc()}>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-6">
                            <ul className="menu-block">
                                <li className="menu__link"><a href="http://tsiko.pp.ua/">Розробник</a></li>
                                <li className="menu__link"><a href="https://newsapi.org/">API News</a></li>
                                <li className="menu__link"><a href="https://api.privatbank.ua/">API Rate</a></li>
                                <li className="menu__link"><a href="http://tsiko.pp.ua/">Інші проєкти</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Menu;